import axios from '../api/axios';

export async function getMakes(options) {
  const res = await axios.get(`/vehicleMakes`, options);

  return res.data;
}
export async function createMake(body) {
  console.log(body);
  const response = await axios.post('/vehicleMakes', JSON.stringify(body), {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
}

export async function updateMake(MakeId, body) {
  const response = await axios.patch(`/vehicleMakes/${MakeId}`, JSON.stringify(body), {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
}

export async function deleteMake(MakeId) {
  const response = await axios.delete(`/vehicleMakes/${MakeId}`);
  return response;
}
